import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 25px;
  height: 25px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  "aria-label": "instellingen"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M20.2 12.6l-.1-1L22.4 9l-2-3.6-3.3.8a8 8 0 0 0-1.8-1l-1-3.3h-4.2l-.9 3.3c-.6.2-1.2.6-1.8 1l-3.2-.8L2 9l2.3 2.5a8.4 8.4 0 0 0 0 2l-2.3 2.5 2 3.6 3.3-.8a8 8 0 0 0 1.8 1l1 3.3h4.2l.9-3.3c.6-.2 1.2-.6 1.8-1l3.2.8 2.1-3.6c0-.1-.7-1-2.3-2.5v-1zm-8 3.7c-2 0-3.6-1.7-3.6-3.7a3.7 3.7 0 1 1 7.3 0c0 2-1.6 3.7-3.7 3.7z"
})));